import React, { useRef, useEffect, useState } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Image, Dropdown, Menu } from "antd";
import { NavLink } from "react-router-dom";
import netImage from "../../../../assets/images/netImage.png";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import { downloadImageCommon, exportChatFile, currencyFormatInt } from "../../../../helpers/utilities";
import { Tooltip, IconButton } from "@mui/material";
import infoMarkIcon from "../../../../assets/images/icon_actions/infoMark.svg";

export const NetIncome = (props) => {
    const { title, monthPercent, currentMonthTotal, lastMonthTotal } = props;
    const monthlySales = useRef(null);
    const classes = customStyles();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
    }, []);

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(monthlySales.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [
            ['Last Month', 'Current Month', 'Percentage'],
            [lastMonthTotal, currentMonthTotal, monthPercent.toFixed(2)]
        ];
        exportChatFile(title, newHead);
    }

    //let width = swiper !== '' ? document.querySelectorAll(`#swiper-admin-details .swiper-pagination`)[0].offsetWidth : 0;
    return (
        <div ref={monthlySales} className={clsx(classes.monthlyDiv, { [classes.monthlySalesLoading]: loading })}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                {`${title}`}
                <Tooltip
                    classes={{ popper: classes.customToolTip }}
                    title={'Values displayed includes only original transaction data and does not include any reversals or credit note'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                    <IconButton>
                        <Image src={infoMarkIcon} preview={false} />
                    </IconButton>
                </Tooltip>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={classes.netIncomeWrapOuter}>
                <div className={classes.netIncomeWrap}>
                    <div className={classes.bgColorBlock}></div>
                    <div className={classes.colorBlocks}>
                        <div className={`${classes.cBlock} ${classes.cBlock1}`}>
                            <div className={classes.textWrap}>
                                <div className={classes.textInfo}>
                                    Last Month
                                </div>
                                <div className={classes.textPrice}>
                                    ₹ {currencyFormatInt(lastMonthTotal)}
                                </div>
                            </div>
                        </div>
                        <div className={`${classes.cBlock} ${classes.cBlock2}`}>
                            <div className={classes.textWrap}>
                                <div className={classes.textInfo}>
                                    Current Month
                                </div>
                                <div className={classes.textPrice}>
                                    ₹ {currencyFormatInt(currentMonthTotal)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.colorCircle}>
                        <img src={netImage} alt={title} />
                    </div>
                </div>
            </div>
        </div>
    );
}